/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Archive_TitleInputs */

const fr_vehicle_action_archive_title = /** @type {(inputs: Vehicle_Action_Archive_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archiver ce véhicule`)
};

const en_vehicle_action_archive_title = /** @type {(inputs: Vehicle_Action_Archive_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archive this vehicle`)
};

/**
* | output |
* | --- |
* | "Archive this vehicle" |
*
* @param {Vehicle_Action_Archive_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_archive_title = /** @type {((inputs?: Vehicle_Action_Archive_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Archive_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_archive_title(inputs)
	return en_vehicle_action_archive_title(inputs)
});